import styled from 'styled-components';

import { responsive, sp } from '@main/theme';

/**
 * Icon
 */
export const Icon = styled.img`
  align-self: center;
  flex-shrink: 0; // Make sure that this doesn't get squished by the text

  ${responsive.beforeTablet} {
    width: ${sp(5)};
    height: ${sp(5)};
    margin-right: ${sp(1)};
  }

  ${responsive.atLeastTablet} {
    width: ${sp(6.5)};
    height: ${sp(6.5)};
    margin-right: ${sp(2)};
  }
`;
